import { render, staticRenderFns } from "./ParceirosLista.vue?vue&type=template&id=ff73a5dc&scoped=true&"
import script from "./ParceirosLista.vue?vue&type=script&lang=js&"
export * from "./ParceirosLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff73a5dc",
  null
  
)

export default component.exports